import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryLegacyPathRedirectRoute: InvariantJiraRoute = {
	name: 'projects-directory-legacy-path-spa-redirect',
	path: '/secure/BrowseProjects.jspa',
};
